import { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import useDebouncedEffect from '../../common/useDebouncedEffect';

type Props = {
  onChange: (value: string) => void;
};

function SearchField({ onChange }: Props) {
  const [value, setValue] = useState('');

  useDebouncedEffect(
    () => {
      onChange(value);
    },
    [value],
    300,
  );

  return (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="p-inputtext-sm"
        placeholder="Search..."
      />
    </span>
  );
}

export default SearchField;
